import { render, staticRenderFns } from "./ERegisterForm.vue?vue&type=template&id=fe58d8a6&"
import script from "./ERegisterForm.vue?vue&type=script&lang=js&"
export * from "./ERegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe58d8a6')) {
      api.createRecord('fe58d8a6', component.options)
    } else {
      api.reload('fe58d8a6', component.options)
    }
    module.hot.accept("./ERegisterForm.vue?vue&type=template&id=fe58d8a6&", function () {
      api.rerender('fe58d8a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/forms/ERegisterForm.vue"
export default component.exports